import React from 'react';
import { SimpleGrid, Center, Button, Text } from '@chakra-ui/react';
import { FormProvider, UseFormReturn } from 'react-hook-form';
import Field from '../form/Field';
import { useTranslation } from 'react-i18next';
import { FilterField } from 'shared/types/filters';
import useGetColors from 'shared/hooks/useGetColors';

interface Props {
  fields: FilterField[],
  methods: UseFormReturn<UnknownRecord, FixMeLater, undefined>;
  handleSaveColumns: (values: UnknownRecord) => void
}

const ShowColumnsForm = ({ fields, methods, handleSaveColumns }: Props) => {
  const { t } = useTranslation();
  const { blue500, blue800, white } = useGetColors();

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(handleSaveColumns)} style={{ width: "100%" }}>
        <Text marginTop={5} fontSize="20px" py="16px" fontWeight="600" mr="auto">
          {t('general.showColumns')}
        </Text>
        <SimpleGrid columns={{ base: 2, md: 3 }} spacing={5} marginBottom={10} width="100%" position="relative" zIndex={1}>
          {fields.map(field => <Field key={field.name} {...field} />)}
        </SimpleGrid>
        <Center>
          <Button type="submit" bgColor={blue500} color={white} width="70%" _hover={{ background: blue800 }}>
            {t('buttons.apply')}
          </Button>
        </Center>
      </form>
    </FormProvider>
  );
}

export default ShowColumnsForm;
